import qs from 'qs';
var stringifyQueryObject = function (queryObject) {
    return qs.stringify(queryObject, {
        // brackets array format is the format expected by Rails.
        arrayFormat: 'brackets',
        skipNulls: true
    });
};
var parseQueryString = function (querystring) {
    return qs.parse(querystring, {
        ignoreQueryPrefix: true
    });
};
var URL_REGEX = /(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/;
export { parseQueryString, stringifyQueryObject, URL_REGEX };
//# sourceMappingURL=urlUtils.js.map